 import React from 'react';
 
 
 function Footer() {
 
   return (
    <footer>
    <div className="comp-footer">
      <div className="container">
        <div className="about-us hide-desktop">
          <div className="logo">
            <img
              src="../../../../assets/images/onboarding/PayU-white-icon.svg"
              alt="logo"
              className="img-responsive"
            />
          </div>
          <p>
            PayU is a leading financial services provider in global growth
            markets. We empower billions of people and millions of merchants
            to buy and sell online, extending the reach of financial services.
          </p>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-4 col-lg-2 col-xl-2">
            <h3 className="list-title">Product</h3>
            <ul className="list">
              <li className="item">
                <a href="https://www.payu.in/payment-gateway">
                  Payment Gateway
                </a>
              </li>
              <li className="item">
                <a href="https://www.payu.in/payment-solutions/payouts">
                  Payouts
                </a>
              </li>
              <li className="item">
                <a href="https://www.payu.in/payment-solutions/online-invoices">
                  Invoices
                </a>
              </li>
              <li className="item">
                <a href="https://www.payu.in/payment-solutions/payment-buttons">
                  Buttons
                </a>
              </li>
              <li className="item">
                <a href="https://www.payu.in/explore/payment-links">
                  Payment Links
                </a>
              </li>
              <li className="item">
                <a href="https://www.payu.in/payment-solutions/payment-website">
                  Payment Website/Store
                </a>
              </li>
              <li className="item">
                <a href="https://www.payu.in/payment-solutions/excel-payment-plugin">
                  Excel Plugins
                </a>
              </li>
              <li className="item">
                <a href="https://www.payu.in/payment-solutions/bharat-qr">
                  QR Code
                </a>
              </li>
              <li className="item">
                <a href="https://www.payu.in/enterprise-payment-solutions">
                  Enterprise Solutions
                </a>
              </li>
            </ul>
          </div>
          <div className="col-sm-12 col-md-4 col-lg-2 col-xl-2">
            <h3 className="list-title">company</h3>
            <ul className="list">
              <li className="item">
                <a href="https://www.payu.in/about-us" target="_blank">
                  About Us
                </a>
              </li>
              <li className="item">
                <a href="https://www.payu.in/careers" target="_blank">
                  Careers
                </a>
              </li>
              <li className="item">
                <a
                  href="https://blog.payumoney.com/?utm_source=website&utm_medium=blog&utm_content=header"
                  target="_blank"
                >
                  Blog
                </a>
              </li>
              <li className="item">
                <a href="https://help.payu.in/" target="_blank">
                  Help &amp; Support
                </a>
              </li>
              <li className="item">
                <a href="https://www.payu.in/privacy-policy" target="_blank">
                  India Privacy Statement
                </a>
              </li>
              <li className="item">
                <a
                  href="https://india.payu.com/privacy-portal/"
                  target="_blank"
                >
                  Privacy Portal
                </a>
              </li>
              <li className="item">
                <a href="https://www.payu.in/cyber-security" target="_blank">
                  Cyber Security
                </a>
              </li>
              <li className="item">
                <a href="https://www.payu.in/tnc" target="_blank">
                  Terms &amp; Conditions
                </a>
              </li>
              <li className="item">
                <a href="https://help.payu.in/" target="_blank">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          <div className="col-sm-12 col-md-4 col-lg-2 col-xl-2">
            <h3 className="list-title">developer</h3>
            <ul className="list">
              <li className="item">
                <a
                  href="https://devguide.payu.in/docs/developers-guide/checkout/"
                  target="_blank"
                >
                  Docs
                </a>
              </li>
              <li className="item">
                <a href="https://api-playground.payu.in/" target="_blank">
                  API Playground
                </a>
              </li>
              <li className="item">
                <a href="https://partner.payu.in/" target="_blank">
                  Partners
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-12 col-xl-4 col-lg-4 offset-lg-2 offset-xl-2">
            <div className="about-us">
              <div className="logo">
                <img
                  src="../../../../assets/images/onboarding/PayU-white-icon.svg"
                  alt="logo"
                  className="img-responsive"
                />
              </div>
              <p>
                PayU is a leading financial services provider in global growth
                markets. We empower billions of people and millions of
                merchants to buy and sell online, extending the reach of
                financial services.
              </p>
            </div>
            <ul className="social-list">
              <li className="item">
                <a
                  href="https://www.facebook.com/PayU.India/"
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={20}
                    height={20}
                    viewBox="0 0 10 16"
                    className="svg-icon-hover"
                  >
                    <g fill="none" fillRule="evenodd">
                      <g fill="#FFF" fillRule="nonzero">
                        <g>
                          <g>
                            <path
                              d="M2.932 15.964l-.023-7.256H0V5.805h2.91V3.991C2.91 1.298 4.58 0 6.987 0c1.154 0 2.145.086 2.434.124v2.814l-1.67.001c-1.31 0-1.563.621-1.563 1.532v1.334H10L8.545 8.708H6.19v7.256H2.932z"
                              transform="translate(-905 -12077) translate(0 11852) translate(905 225)"
                              fill="#A7A7A7"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
              <li className="item">
                <a href="https://twitter.com/PayUindia" target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={20}
                    height={20}
                    viewBox="0 0 16 14"
                    className="svg-icon-hover"
                  >
                    <g fill="none" fillRule="evenodd">
                      <g fill="#FFF" fillRule="nonzero">
                        <g>
                          <g>
                            <g>
                              <path
                                d="M16 1.73c-.6.266-1.2.465-1.867.532.667-.4 1.2-1.065 1.467-1.796-.667.399-1.333.665-2.067.798C12.933.599 12.067.2 11.133.2c-1.8 0-3.266 1.463-3.266 3.259 0 .266 0 .532.066.732-2.8-.133-5.2-1.464-6.8-3.46C.8 1.265.667 1.797.667 2.396c0 1.13.6 2.128 1.466 2.727-.533 0-1.066-.133-1.466-.4v.067c0 1.597 1.133 2.927 2.6 3.193-.267.067-.534.133-.867.133-.2 0-.4 0-.6-.066.4 1.33 1.6 2.261 3.067 2.261-1.134.865-2.534 1.397-4.067 1.397-.267 0-.533 0-.8-.066 1.467.93 3.2 1.463 5 1.463 6.067 0 9.333-4.989 9.333-9.313v-.399C15 2.927 15.533 2.328 16 1.73z"
                                transform="translate(-979 -12078) translate(0 11852) translate(905 225) translate(74 .998)"
                                fill="#A7A7A7"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
              <li className="item">
                <a
                  href="https://www.instagram.com/payuindia/"
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={20}
                    height={20}
                    viewBox="0 0 16 16"
                    className="svg-icon-hover"
                  >
                    <g fill="none" fillRule="evenodd">
                      <g fill="#A7A7A7" fillRule="nonzero">
                        <g>
                          <g>
                            <g transform="translate(-1019 -12077) translate(0 11852) translate(905 225) translate(114)">
                              <circle cx="12.145" cy="3.883" r={1} />
                              <path d="M8 11.973c-2.206 0-4-1.79-4-3.99C4 5.78 5.794 3.99 8 3.99s4 1.79 4 3.991-1.794 3.991-4 3.991zm0-5.986c-1.103 0-2 .895-2 1.995s.897 1.996 2 1.996 2-.895 2-1.996c0-1.1-.897-1.995-2-1.995z" />
                              <path
                                d="M12 15.964H4c-2.056 0-4-1.94-4-3.99V3.99C0 1.94 1.944 0 4 0h8c2.056 0 4 1.94 4 3.991v7.982c0 2.051-1.944 3.991-4 3.991zM4 1.996c-.935 0-2 1.062-2 1.995v7.982c0 .951 1.047 1.996 2 1.996h8c.935 0 2-1.063 2-1.996V3.991c0-.933-1.065-1.995-2-1.995H4z"
                                fill="#A7A7A7"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
              <li className="item">
                <a
                  href="https://www.linkedin.com/company/payu/?originalSubdomain=in"
                  target="_blank"
                >
                  <svg
                    className="svg-icon-hover"
                    width={18}
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 53c2.5 0 1.7-2 1.9-3.3C5.9 29 16.6 13.9 36.6 7.4c16.1-5.2 32.9-4.6 47.9 4 9.4 5.5 16.6 14 20.4 24.5 2.8 7.8 4.9 15.9 4 24.2-2.1 20.9-11.5 38.3-34.5 46.4-17.4 6-34.3 3.8-50.2-5.7-1-3.6-3.5-5.4-7.1-6-.1-1.4-.3-2.8-2.2-2.8-7.2-8-10.6-17.7-12-28.2-.2-1.2.3-2.9-1.9-2.8v-8zM276.2 216.1c4.3-2.6 6-6.4 8.2-9.5 10.9-15 24.4-26.6 41.2-34.9 23-11.3 47.4-12.5 72-10.2 18.9 1.7 36.8 8.1 53.1 18.5 19.4 12.4 33.3 29.6 42.8 50.2 5.8 12.5 9.6 25.8 11.9 39.6 2.1 12.9 3.7 25.6 3.7 38.7-.1 65-.1 130 .1 195 0 4.6-1.3 5.8-5.8 5.7-30.7-.2-61.3-.2-92 0-4.5 0-5.5-1.3-5.5-5.6.1-61.3.4-122.7-.1-184-.1-13.9-2-27.7-9.2-40.4-6.4-11.2-15.3-19.2-27-23.8-15.7-6.2-31.9-7.4-48.3-2.8-16.6 4.6-28.1 15.5-36.3 30.3-4.6 8.3-6.2 17-7.5 26.3-1.3 10-1.1 19.8-1.1 29.7-.2 54.7-.2 109.3 0 164 0 5-1.2 6.4-6.3 6.3-30.3-.3-60.7-.2-91 0-4.2 0-5.7-1.3-5.6-5.2.1-2.8.3-5.6.3-8.4 0-105.5.1-211-.1-316.5 0-4.4.9-6 5.7-6 30.5.2 61 .2 91.5 0 4.1 0 5.5 1 5.4 5.3-.3 12.2-.1 24.5-.1 37.7zM109 176.1c0 3.5.1 7 .1 10.5v316c0 6.4 0 6.4-6.5 6.4H7.1c-.1-2.5-.2-5-.2-7.5V265.2c0-28.1.1-56.3-.1-84.4 0-3.6.9-4.9 4.7-4.9 32.5.2 65 .1 97.5.2z"
                      fill="#A7A7A7"
                    />
                    <path
                      d="M109 176.1c-32.5 0-64.9 0-97.4-.2-3.8 0-4.7 1.2-4.7 4.9.1 28.1 0 56.2 0 84.4v236.3c0 2.5.1 5 .2 7.5-1.7.1-3-.3-3-2.3v-4-320.3c0-7.6.7-8.3 8.2-8.3 30.5 0 61 0 91.4.1 1.8-.1 4.5-1.5 5.3 1.9zM17.1 94.9c3.6.6 6.1 2.4 7.1 6-3.1-1.2-5.4-3.2-7.1-6zM14.9 92.1c1.9 0 2 1.4 2.2 2.8-2.1.1-2.1-1.3-2.2-2.8z"
                      fill="#E0E0E0"
                    />
                  </svg>
                </a>
              </li>
              <li className="item">
                <a href="https://www.youtube.com/c/payuindia" target="_blank">
                  <svg
                    viewBox="0 0 512 512"
                    width={20}
                    xmlns="http://www.w3.org/2000/svg"
                    className="svg-icon-hover"
                  >
                    <path
                      d="M256.4 74.2c22.7 0 45.3-.4 68 .1 28.8.6 57.6 1.7 86.3 3 11.9.6 24 .9 35.8 3.2 28.1 5.4 44.8 22.7 52.5 50 4.1 14.5 5.6 29.4 6.9 44.3 3.5 40.1 2.8 80.2 1.8 120.3-.6 23.7-1.6 47.6-7.6 70.8-2.5 9.5-5.4 19-10.9 27.3-10 15.1-24.4 23.7-42 26.9-15.1 2.8-30.4 3.1-45.7 3.8-28.3 1.3-56.6 1.9-84.9 2.6-33.5.9-67 .7-100.4.4-27.1-.3-54.3-.9-81.4-2-22.9-.9-45.9-1.3-68.5-5.7-12.5-2.4-23.6-7.6-33.2-16.2-9-8.2-13.6-18.8-17-30-7.3-24-7.8-48.8-9.3-73.6-1.7-29-1.2-58-.5-86.9.6-24.4 1.7-48.9 6.8-72.9 3-14.2 7.1-28.3 17.4-39.2C43.2 87 59.4 80.6 77.7 79.3c21.9-1.5 43.9-2.5 65.8-3.4 37.6-1.6 75.3-2.1 112.9-1.7zm83.1 171.2c-.4-1.2-1.5-1.4-2.3-1.8-23.5-12.4-47.1-24.8-70.7-37.2-18.7-9.8-37.4-19.7-56.1-29.6-5.2-2.7-5.3-2.6-5.3 3.4v131.9c-.1 2.6.9 3.4 3.3 2.1 2.9-1.6 5.8-3.2 8.8-4.8 39.4-20.4 78.9-40.9 118.3-61.3 1.4-.8 3.2-1.1 4-2.7z"
                      fill="#A7A7A7"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="hide-desktop">
          <ul className="social-list">
            <li className="item">
              <a href="https://www.facebook.com/PayU.India/" target="_blank">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={20}
                  height={20}
                  viewBox="0 0 10 16"
                  className="svg-icon-hover svg-icon-hover-mobile"
                >
                  <g fill="none" fillRule="evenodd">
                    <g fill="#FFF" fillRule="nonzero">
                      <g>
                        <g>
                          <path
                            d="M2.932 15.964l-.023-7.256H0V5.805h2.91V3.991C2.91 1.298 4.58 0 6.987 0c1.154 0 2.145.086 2.434.124v2.814l-1.67.001c-1.31 0-1.563.621-1.563 1.532v1.334H10L8.545 8.708H6.19v7.256H2.932z"
                            transform="translate(-905 -12077) translate(0 11852) translate(905 225)"
                            fill="#A7A7A7"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>
            <li className="item">
              <a href="https://twitter.com/PayUindia" target="_blank">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={20}
                  height={20}
                  viewBox="0 0 16 14"
                  className="svg-icon-hover svg-icon-hover-mobile"
                >
                  <g fill="none" fillRule="evenodd">
                    <g fill="#FFF" fillRule="nonzero">
                      <g>
                        <g>
                          <g>
                            <path
                              d="M16 1.73c-.6.266-1.2.465-1.867.532.667-.4 1.2-1.065 1.467-1.796-.667.399-1.333.665-2.067.798C12.933.599 12.067.2 11.133.2c-1.8 0-3.266 1.463-3.266 3.259 0 .266 0 .532.066.732-2.8-.133-5.2-1.464-6.8-3.46C.8 1.265.667 1.797.667 2.396c0 1.13.6 2.128 1.466 2.727-.533 0-1.066-.133-1.466-.4v.067c0 1.597 1.133 2.927 2.6 3.193-.267.067-.534.133-.867.133-.2 0-.4 0-.6-.066.4 1.33 1.6 2.261 3.067 2.261-1.134.865-2.534 1.397-4.067 1.397-.267 0-.533 0-.8-.066 1.467.93 3.2 1.463 5 1.463 6.067 0 9.333-4.989 9.333-9.313v-.399C15 2.927 15.533 2.328 16 1.73z"
                              transform="translate(-979 -12078) translate(0 11852) translate(905 225) translate(74 .998)"
                              fill="#A7A7A7"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>
            <li className="item">
              <a href="https://www.instagram.com/payuindia/" target="_blank">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={20}
                  height={20}
                  viewBox="0 0 16 16"
                  className="svg-icon-hover svg-icon-hover-mobile"
                >
                  <g fill="none" fillRule="evenodd">
                    <g fill="#A7A7A7" fillRule="nonzero">
                      <g>
                        <g>
                          <g transform="translate(-1019 -12077) translate(0 11852) translate(905 225) translate(114)">
                            <circle cx="12.145" cy="3.883" r={1} />
                            <path d="M8 11.973c-2.206 0-4-1.79-4-3.99C4 5.78 5.794 3.99 8 3.99s4 1.79 4 3.991-1.794 3.991-4 3.991zm0-5.986c-1.103 0-2 .895-2 1.995s.897 1.996 2 1.996 2-.895 2-1.996c0-1.1-.897-1.995-2-1.995z" />
                            <path
                              d="M12 15.964H4c-2.056 0-4-1.94-4-3.99V3.99C0 1.94 1.944 0 4 0h8c2.056 0 4 1.94 4 3.991v7.982c0 2.051-1.944 3.991-4 3.991zM4 1.996c-.935 0-2 1.062-2 1.995v7.982c0 .951 1.047 1.996 2 1.996h8c.935 0 2-1.063 2-1.996V3.991c0-.933-1.065-1.995-2-1.995H4z"
                              fill="#A7A7A7"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>
            <li className="item">
              <a
                href="https://www.linkedin.com/company/payu/?originalSubdomain=in"
                target="_blank"
              >
                <svg
                  className="svg-icon-hover svg-icon-hover-mobile"
                  width={18}
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 53c2.5 0 1.7-2 1.9-3.3C5.9 29 16.6 13.9 36.6 7.4c16.1-5.2 32.9-4.6 47.9 4 9.4 5.5 16.6 14 20.4 24.5 2.8 7.8 4.9 15.9 4 24.2-2.1 20.9-11.5 38.3-34.5 46.4-17.4 6-34.3 3.8-50.2-5.7-1-3.6-3.5-5.4-7.1-6-.1-1.4-.3-2.8-2.2-2.8-7.2-8-10.6-17.7-12-28.2-.2-1.2.3-2.9-1.9-2.8v-8zM276.2 216.1c4.3-2.6 6-6.4 8.2-9.5 10.9-15 24.4-26.6 41.2-34.9 23-11.3 47.4-12.5 72-10.2 18.9 1.7 36.8 8.1 53.1 18.5 19.4 12.4 33.3 29.6 42.8 50.2 5.8 12.5 9.6 25.8 11.9 39.6 2.1 12.9 3.7 25.6 3.7 38.7-.1 65-.1 130 .1 195 0 4.6-1.3 5.8-5.8 5.7-30.7-.2-61.3-.2-92 0-4.5 0-5.5-1.3-5.5-5.6.1-61.3.4-122.7-.1-184-.1-13.9-2-27.7-9.2-40.4-6.4-11.2-15.3-19.2-27-23.8-15.7-6.2-31.9-7.4-48.3-2.8-16.6 4.6-28.1 15.5-36.3 30.3-4.6 8.3-6.2 17-7.5 26.3-1.3 10-1.1 19.8-1.1 29.7-.2 54.7-.2 109.3 0 164 0 5-1.2 6.4-6.3 6.3-30.3-.3-60.7-.2-91 0-4.2 0-5.7-1.3-5.6-5.2.1-2.8.3-5.6.3-8.4 0-105.5.1-211-.1-316.5 0-4.4.9-6 5.7-6 30.5.2 61 .2 91.5 0 4.1 0 5.5 1 5.4 5.3-.3 12.2-.1 24.5-.1 37.7zM109 176.1c0 3.5.1 7 .1 10.5v316c0 6.4 0 6.4-6.5 6.4H7.1c-.1-2.5-.2-5-.2-7.5V265.2c0-28.1.1-56.3-.1-84.4 0-3.6.9-4.9 4.7-4.9 32.5.2 65 .1 97.5.2z"
                    fill="#A7A7A7"
                  />
                  <path
                    d="M109 176.1c-32.5 0-64.9 0-97.4-.2-3.8 0-4.7 1.2-4.7 4.9.1 28.1 0 56.2 0 84.4v236.3c0 2.5.1 5 .2 7.5-1.7.1-3-.3-3-2.3v-4-320.3c0-7.6.7-8.3 8.2-8.3 30.5 0 61 0 91.4.1 1.8-.1 4.5-1.5 5.3 1.9zM17.1 94.9c3.6.6 6.1 2.4 7.1 6-3.1-1.2-5.4-3.2-7.1-6zM14.9 92.1c1.9 0 2 1.4 2.2 2.8-2.1.1-2.1-1.3-2.2-2.8z"
                    fill="#E0E0E0"
                  />
                </svg>
              </a>
            </li>
            <li className="item">
              <a href="https://www.youtube.com/c/payuindia" target="_blank">
                <svg
                  viewBox="0 0 512 512"
                  width={20}
                  xmlns="http://www.w3.org/2000/svg"
                  className="svg-icon-hover svg-icon-hover-mobile"
                >
                  <path
                    d="M256.4 74.2c22.7 0 45.3-.4 68 .1 28.8.6 57.6 1.7 86.3 3 11.9.6 24 .9 35.8 3.2 28.1 5.4 44.8 22.7 52.5 50 4.1 14.5 5.6 29.4 6.9 44.3 3.5 40.1 2.8 80.2 1.8 120.3-.6 23.7-1.6 47.6-7.6 70.8-2.5 9.5-5.4 19-10.9 27.3-10 15.1-24.4 23.7-42 26.9-15.1 2.8-30.4 3.1-45.7 3.8-28.3 1.3-56.6 1.9-84.9 2.6-33.5.9-67 .7-100.4.4-27.1-.3-54.3-.9-81.4-2-22.9-.9-45.9-1.3-68.5-5.7-12.5-2.4-23.6-7.6-33.2-16.2-9-8.2-13.6-18.8-17-30-7.3-24-7.8-48.8-9.3-73.6-1.7-29-1.2-58-.5-86.9.6-24.4 1.7-48.9 6.8-72.9 3-14.2 7.1-28.3 17.4-39.2C43.2 87 59.4 80.6 77.7 79.3c21.9-1.5 43.9-2.5 65.8-3.4 37.6-1.6 75.3-2.1 112.9-1.7zm83.1 171.2c-.4-1.2-1.5-1.4-2.3-1.8-23.5-12.4-47.1-24.8-70.7-37.2-18.7-9.8-37.4-19.7-56.1-29.6-5.2-2.7-5.3-2.6-5.3 3.4v131.9c-.1 2.6.9 3.4 3.3 2.1 2.9-1.6 5.8-3.2 8.8-4.8 39.4-20.4 78.9-40.9 118.3-61.3 1.4-.8 3.2-1.1 4-2.7z"
                    fill="#A7A7A7"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </div>
        <div className="copyrights">
          © Copyright {new Date().getFullYear()}, PayU. All rights are reserved.
        </div>
      </div>
    </div>
  </footer>
   );
 }
 
 export default Footer;
